export type ItemProps = {
  id: number;
  label: string;
  description?: string;
  url: string;
  isEmail?: boolean;
};

export type MenuItemProps = {
  id: number;
  label: string;
  url: string;
  items?: ItemProps[];
};

export type SiteProps = {
  id: number;
  label: string;
  available: boolean;
  url: string;
  current?: boolean;
};

export const allSites: SiteProps[] = [
  {
    id: 1,
    label: "Main Gateway",
    available: true,
    url: "https://g2aging.org",
  },
  {
    id: 2,
    label: "COVID",
    available: true,
    url: "https://covid.g2aging.org",
    current: true,
  },
  {
    id: 3,
    label: "Exposome",
    available: true,
    url: "https://exposome.g2aging.org",
  },
  {
    id: 4,
    label: "End of Life",
    available: true,
    url: "https://eol.g2aging.org",
  },
  {id: 5, label: "HCAP", available: true, url: "https://hcap.g2aging.org"},
  {id: 6, label: "Life History", available: false, url: ""},
  {
    id: 7,
    label: "Data Enclave",
    available: true,
    url: "https://g2aging.org/enclave",
  },
];

export const headerItems: MenuItemProps[] = [
  {id: 1, label: "Getting Started", url: "/getting-started"},
  {
    id: 2,
    label: "Health and Reirement COVID Studies",
    url: "/health-and-retirement-studies",
    items: [
      {
        id: 21,
        label: "Overview",
        description:
          "Find information about the COVID-19 data collection cataloged by the Gateway",
        url: "/health-and-retirement-studies/overview",
      },
      {
        id: 22,
        label: "Questionnaires",
        description: "View survey questionnaires",
        url: "/health-and-retirement-studies/questionnaire",
      },
      {
        id: 23,
        label: "Search",
        description: "Search through survey questionnaires",
        url: "/health-and-retirement-studies/search",
      },
      {
        id: 24,
        label: "Get Data",
        description: "Links to download survey data",
        url: "/health-and-retirement-studies/get-data",
      },
    ],
  },
  {
    id: 3,
    label: "Harmonized COVID Data",
    url: "/harmonized-covid-data",

    items: [
      {
        id: 31,
        label: "Overview",
        description: "Find information about each Harmonized dataset",
        url: "/harmonized-covid-data/overview",
      },
      {
        id: 32,
        label: "Search",
        description: "Search for Harmonized variables",
        url: "/harmonized-covid-data/search",
      },
      {
        id: 33,
        label: "Get Data",
        description: "Links to download Harmonized data",
        url: "/harmonized-covid-data/get-data",
      },
    ],
  },
  {id: 5, label: "COVID Policies", url: "/covid-policies"},
  {
    id: 6,
    label: "Additional COVID Resources",
    url: "/additional-covid-resources",
    items: [
      {
        id: 61,
        label: "COVID Publications",
        description:
          "Search publications based on the family of HRS surveys around the world",
        url: "/additional-covid-resources/publications",
      },
      {
        id: 62,
        label: "Additional Resources",
        description: "Find other additional helpful resources",
        url: "/additional-covid-resources/resources",
      },
    ],
  },
];

export const footerItems: MenuItemProps[] = [
  {
    id: 1,
    label: "Quick Links",
    url: "/",
    items: [
      {
        id: 11,
        label: "Study Overview",
        url: "/health-and-retirement-studies/overview",
      },
      {
        id: 12,
        label: "Harmonized Data Overview",
        url: "/harmonized-covid-data/overview",
      },
      {
        id: 13,
        label: "Covid Policies",
        url: "/covid-policies",
      },
    ],
  },
  {
    id: 2,
    label: "Help and Support",
    url: "/",
    items: [
      {
        id: 21,
        label: "Help Desk",
        url: "mailto:help@g2aging.org",
        isEmail: true,
      },
    ],
  },
];
